var _desc, _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcChatting(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "123px",
    height: "98px",
    viewBox: "0 0 123 98",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icChatting") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M73,10.8041695 C48.7899184,14.7968585 31.7275737,30.7821463 31.7275737,52.1646153 C31.7275737,58.4724853 33.2128669,64.4487693 35.9288078,69.8537738 L19.1545419,80.7923464 C18.9442743,80.9299813 18.7009348,81 18.4575953,81 C18.2522015,81 18.0443708,80.9498886 17.8570794,80.8500089 C17.4462918,80.6324017 17.1904198,80.2078273 17.1904198,79.750303 L17.1904198,61.9470114 C6.09567133,56.2590193 0,46.300228 0,33.8224785 C0,14.5395264 17.9785751,0 41.8227108,0 C54.4664578,0 65.4609112,4.08826164 73,10.8041695 Z M12,37 C14.209139,37 16,35.209139 16,33 C16,30.790861 14.209139,29 12,29 C9.790861,29 8,30.790861 8,33 C8,35.209139 9.790861,37 12,37 Z M29,37 C31.209139,37 33,35.209139 33,33 C33,30.790861 31.209139,29 29,29 C26.790861,29 25,30.790861 25,33 C25,35.209139 26.790861,37 29,37 Z",
    id: "path-1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.243497,98 C103.996217,98 103.748937,97.9282524 103.535264,97.7872192 L82.9108934,84.2255184 L82.859244,84.2279804 C82.076367,84.2691297 81.2959663,84.3123893 80.5,84.3123893 C56.2697254,84.3123893 38,69.4138622 38,49.6576015 C38,29.8985271 56.2697254,15 80.5,15 C104.730275,15 123,29.8985271 123,49.6576015 C123,62.4434435 116.805614,72.6481309 105.531194,78.4765672 L105.531194,96.7194463 C105.531194,97.1882675 105.271178,97.6233252 104.853738,97.8463054 C104.663413,97.9486512 104.452217,98 104.243497,98 Z M59.2338462,56.92 C62.1244196,56.92 64.4676923,54.4754747 64.4676923,51.46 C64.4676923,48.4445253 62.1244196,46 59.2338462,46 C56.3432727,46 54,48.4445253 54,51.46 C54,54.4754747 56.3432727,56.92 59.2338462,56.92 Z M80.645035,56.92 C83.5356084,56.92 85.8788811,54.4754747 85.8788811,51.46 C85.8788811,48.4445253 83.5356084,46 80.645035,46 C77.7544616,46 75.4111888,48.4445253 75.4111888,51.46 C75.4111888,54.4754747 77.7544616,56.92 80.645035,56.92 Z M102.056224,56.92 C104.946797,56.92 107.29007,54.4754747 107.29007,51.46 C107.29007,48.4445253 104.946797,46 102.056224,46 C99.1656504,46 96.8223776,48.4445253 96.8223776,51.46 C96.8223776,54.4754747 99.1656504,56.92 102.056224,56.92 Z",
    id: "path-3"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Messanger-empty-state",
    transform: "translate(-699.000000, -289.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icChatting",
    transform: "translate(699.000000, 289.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Combined-Shape",
    fillOpacity: 0.6,
    fill: "#7BCB45",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "mask-4",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-3"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Combined-Shape",
    fill: "#7BCB45",
    xlinkHref: "#path-3"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcChatting);
export default __webpack_public_path__ + "static/media/icChatting.656546cc154df2dd37b648d3f0880eed.svg";
export { ForwardRef as ReactComponent };